import cn from 'classnames';

export interface KeyValueItem {
  key: string;
  value: React.ReactNode;
}

export interface KeyValueStripeTableProps {
  items: KeyValueItem[];
  className?: string;
}

export const KeyValueStripeTable = ({ items, className }: KeyValueStripeTableProps) => (
  <table className={cn('table table-row-bordered mb-0', className)}>
    <tbody>
      {items.map((item, rowIndex) => (
        <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-light' : ''}>
          <td className={cn('fw-semibold fs-7 text-gray-500 py-2 px-3', 'w-150px')}>{item.key}</td>
          <td className="fw-semibold fs-7 text-gray-800 py-2 px-3">{item.value}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
